import React, { ReactNode } from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { Colors, Shadows } from '../../constants';
import type { ModalProps as AntModalProps } from 'antd';

interface ModalProps extends Omit<AntModalProps, 'title'> {
  title: string;
  className?: string;
  closeOnClickOutside?: boolean;
  isOpen?: boolean;
  width?: string | number;
  footer?: ReactNode;
}

const StyledModal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    border-radius: 8px;
  }

  .ant-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    margin: 0;
    border-bottom: 1px solid #e5e7eb;
    background-color: ${Colors.neutral.bg[6]};
    border-radius: 0;
  }

  .ant-modal-title {
    color: white;
    text-align: center;
  }

  .ant-modal-body {
    padding: 0;
    overflow: auto;
    max-height: 90vh;
  }

  .ant-modal-footer {
    margin: 0;
    padding: 1rem;
    box-shadow: ${Shadows.box};
  }

  .ant-modal-close {
    color: white;
    top: 16px;

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  
  .ant-modal-centered &.ant-modal {
    text-align: center;
  }
`;

const Modal: React.FC<ModalProps> = ({
  title,
  children,
  className,
  isOpen,
  closable = false,
  closeOnClickOutside = true,
  width = '48rem',
  maskClosable,
  footer = null,
  ...rest
}) => {
  return (
    <StyledModal
      closable={closable}
      open={isOpen}
      // title={<CustomTitle title_h5_24_semibold_caplock>{title}</CustomTitle>}
      width={width}
      maskClosable={closeOnClickOutside}
      centered
      className={className}
      onCancel={rest.onCancel}
      footer={footer}
      {...rest}
    >
      {children}
    </StyledModal>
  );
};

export default Modal;
